<template>
  <div class="notifications">
    <div class="overlay">
      <UtilityNotification
        v-if="selectedNotificationId !== false"
        :key="'NOTIFICATION__' + selectedNotificationId"
        mode="edit"
        :dataObject="notificationDataObject"
        @closed="closeNotification()"
        @submitted="fetchNotifications()"
        @deleted="fetchNotifications()"
      />
    </div>

    <div :class="['wrap', selectedNotificationId !== false ? 'wrap--mask' : '']">
      <p>View, edit and delete your email notifications here.<!--<br />You can change email delivery time at <router-link class="link" to="/settings/personalization">Personalization</router-link> settings.--></p>

      <UtilityTable
        class="notifications__table"
        type="notifications"
        :header="[
          { key: 'count', value: '#', width: 'auto' },
          { key: 'name', value: 'Name', width: '100%' },
          { key: 'type', value: 'Type', width: 'auto', capitalizeContent: true, extraRightPadding: true },
          { key: 'frequency', value: 'Frequency', width: 'auto', capitalizeContent: true },
          { key: 'filters', value: '# Filters', width: 'auto', capitalizeContent: true, alignRight: true }
        ]"
        :dataObject="notifications"
        :showSearchLink="true"
        :loading="loading === true ? true : false"
        :editing="selectedNotificationId !== false ? true : false"
        @clicked="setNotification($event)"
      />
    </div>
  </div>
</template>

<script>
import UtilityNotification from '@/components/utility/Notification.vue'
import UtilityTable from '@/components/utility/Table.vue'

export default {
  components: {
    UtilityNotification,
    UtilityTable
  },
  data () {
    return {
      currentView: 'notifications',
      selectedNotificationId: false,
      loading: true
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    notifications () {
      return this.$store.getters['user/getNotifications']
    },
    notificationDataObject () {
      if (this.notifications && this.notifications.byId && this.selectedNotificationId !== false) {
        return this.notifications.byId['NOTIFICATION_' + this.selectedNotificationId]
      }

      return false
    }
  },
  methods: {
    async fetchNotifications () {
      this.selectedNotificationId = false
      this.loading = true
      await this.$store.dispatch('user/fetchNotifications')
      this.loading = false
    },
    setNotification (notificationId) {
      this.selectedNotificationId = notificationId
    },
    closeNotification () {
      this.selectedNotificationId = false
    }
  },
  async created () {
    await this.fetchNotifications()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.notifications {
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  @media screen and (min-width: $breakpointSm) {
    width: 90%;
  }

  p {
    @include font('content--md', $white, 0.9);
    width: 90%;
    margin: 2rem auto 1.5rem auto;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--lg', $white, 0.9);
      margin: 2rem auto 1.5rem auto;
    }
  }

  &__table {
    margin: 2rem auto;
    border-width: 1px 1px 0px 1px;
    border-style: solid;
    border-color: $black;
  }
}

.overlay {
  position: fixed;
  z-index: 10;
  top: 100px;
  left: calc(50% - 225px + 120px);
  width: 450px;

  @media screen and (min-width: $breakpointLg) {
    left: calc(50% - 225px + 140px);
  }
}

.wrap {
  &--mask {
    transition: opacity 0.25s ease-out;
    opacity: 0.1;
  }
}
</style>
